import React from 'react';
import { Button, message, notification } from 'antd';
import dayjs from 'dayjs';
import defaultSettings from '../config/defaultSettings';

// Sets default language
dayjs.locale('es');

if (defaultSettings.pwa) {
  let updateNotified = false;

  // Notify user if offline now
  window.addEventListener('sw.offline', () => {
    message.warning('app.pwa.offline');
  });

  window.addEventListener('sw.updated', (event: Event) => {
    if (updateNotified) return;
    updateNotified = true;

    const e = event as CustomEvent;

    const reloadSW = async () => {
      const worker = e.detail && e.detail.waiting;
      if (!worker) return;

      let reloaded = false;

      const reload = () => {
        if (reloaded) return;
        reloaded = true;
        window.location.reload();
      };

      // Caso ideal: el nuevo SW toma control
      navigator.serviceWorker.addEventListener(
        'controllerchange',
        () => {
          reload();
        },
        { once: true }
      );

      // Fallback: si el evento no llega (muy común)
      setTimeout(() => {
        reload();
      }, 2000);

      // Pedimos activación
      worker.postMessage({ type: 'skip-waiting' });
    };

    const key = `sw-update-${Date.now()}`;

    const btn = (
      <Button
        type="primary"
        onClick={() => {
          notification.destroy(key);
          reloadSW();
        }}
      >
        Actualizar
      </Button>
    );

    notification.open({
      key,
      message:'Nueva versión disponible',
      description:'Hay una nueva versión disponible. Click en Actualizar o presiona F5 para recargar la página.',
      btn,
      duration: 0,
    });
  });

  // Service Worker registration
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('[SW] registrado:', registration);

          // Reset flag when new SW takes control
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            updateNotified = false;
          });

          const checkForUpdates = () => {
            registration.update();
          };

          // Chequeo inmediato
          checkForUpdates();

          // Chequeo al volver a la pestaña
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
              checkForUpdates();
            }
          });

          // Polling suave (1 min)
          setInterval(checkForUpdates, 30_000);

          // Si ya hay uno esperando
          if (registration.waiting) {
            window.dispatchEvent(
              new CustomEvent('sw.updated', { detail: registration }),
            );
          }

          // Detectar nuevo SW instalándose
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (!newWorker) return;

            newWorker.addEventListener('statechange', () => {
              if (
                newWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                window.dispatchEvent(
                  new CustomEvent('sw.updated', { detail: registration }),
                );
              }
            });
          });
        })
        .catch((error) => {
          console.error('Error registrando el ServiceWorker: ', error);
        });
    });
  }
} else if ('serviceWorker' in navigator) {
  const { serviceWorker } = navigator;

  // Unregister all SWs
  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then((sws) => {
      sws.forEach((sw) => sw.unregister());
    });
  }

  serviceWorker.getRegistration().then((sw) => {
    if (sw) sw.unregister();
  });
  
  // Clear caches
  if (window.caches && window.caches.keys) {
    caches.keys().then((keys) => {
      keys.forEach((key) => caches.delete(key));
    });
  }
}
